module.exports = __webpack_public_path__ + "static/media/Icon_Language.58e2b107.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/icons/svg/Icon_Language.svg
// module id = 2319
// module chunks = 0